<div class="map-container">
  <div class="map-frame">
    <div id="map" [ngStyle]="{'height': height}"></div>
    <div class="map-help-button" style="position:absolute; top:8px; right:8px; z-index:500;">
      <button mat-icon-button (click)="showHelp()" matTooltip="Ayuda del mapa">
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
